// extracted by mini-css-extract-plugin
export default {"backgroundImg":"JP_OurCommunity_backgroundImg__kXBgW"};